import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

import { colors } from "@dotnet/telematics-design-system";

const IntegrationErrorIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="currentColor"
      {...props}
    >
      <path
        d="M99.3946 69.7747C84.2866 82.6926 62.0926 85.3866 43.9006 74.8806C25.7086 64.3746 16.9426 43.8066 20.5726 24.2646L99.3886 69.7686L99.3946 69.7747Z"
        fill="url(#paint0_linear_1437_52001)"
      />
      <path
        d="M99.3923 69.769C102.804 63.8602 87.9259 48.8837 66.1616 36.3181C44.3974 23.7525 23.9885 18.3562 20.577 24.265C17.1656 30.1738 32.0434 45.1503 53.8076 57.7159C75.5719 70.2815 95.9808 75.6778 99.3923 69.769Z"
        fill="url(#paint1_linear_1437_52001)"
      />
      <path
        d="M64.6605 38.9222C62.4825 37.6622 59.6925 38.4122 58.4325 40.5902C57.4905 42.2222 57.6705 44.1962 58.7385 45.6122L52.2585 56.8322L55.3485 58.6142L61.8225 47.3942C63.5805 47.6102 65.3805 46.7822 66.3225 45.1502C67.5825 42.9722 66.8325 40.1822 64.6545 38.9222H64.6605Z"
        fill={colors.white}
      />
      <path
        d="M20.1466 26.6762C20.2606 25.7522 20.3986 24.8282 20.5666 23.9102C20.1166 24.6842 19.9906 25.6202 20.1466 26.6762Z"
        fill={colors.white}
      />
      <path
        d="M62.8966 105.936H23.5066C22.1746 105.936 21.0886 104.856 21.0886 103.518V98.292C21.0886 96.966 22.1686 95.874 23.5066 95.874H59.7946C59.7586 96.258 59.7406 96.654 59.7406 97.05C59.7406 100.41 60.9226 103.506 62.8966 105.93V105.936Z"
        fill="url(#paint2_linear_1437_52001)"
      />
      <path
        d="M51.1906 68.9045C49.7926 66.5345 46.3546 66.5345 44.9446 68.9045L29.0266 95.8745H59.7886C60.0166 93.0785 61.0666 90.5105 62.6986 88.4165L51.1846 68.9045H51.1906Z"
        fill="url(#paint3_linear_1437_52001)"
      />
      <path
        d="M66.6887 13.9385C80.6267 13.9385 91.9247 25.2365 91.9247 39.1745"
        stroke="#70B8FF"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M66.6887 20.25C77.1407 20.25 85.6127 28.722 85.6127 39.174"
        stroke="#70B8FF"
        strokeWidth="1.812"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M66.6887 26.5566C73.6547 26.5566 79.3067 32.2086 79.3067 39.1746"
        stroke="#70B8FF"
        strokeWidth="1.812"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M86.7165 97.056C86.7165 104.16 80.9385 109.938 73.8345 109.938C70.1745 109.938 66.8625 108.402 64.5165 105.936C62.3085 103.632 60.9465 100.5 60.9465 97.056C60.9465 96.66 60.9645 96.264 61.0005 95.88C61.2105 93.534 62.0625 91.362 63.3705 89.55C65.7045 86.292 69.5205 84.168 73.8285 84.168C80.9325 84.168 86.7105 89.946 86.7105 97.05L86.7165 97.056Z"
        fill="#70B8FF"
      />
      <path
        d="M81.3045 91.8061L79.0785 89.5801L73.8345 94.8241L68.5905 89.5801L66.3645 91.8061L71.6085 97.0501L66.3645 102.3L68.5905 104.526L73.8345 99.2761L79.0785 104.526L81.3045 102.3L76.0605 97.0501L81.3045 91.8061Z"
        fill={colors.white}
      />
      <path
        d="M50.2305 71.6159C50.2305 72.8099 49.2645 73.7759 48.0705 73.7759C46.8765 73.7759 45.9165 72.8099 45.9165 71.6159C45.9165 70.4219 46.8825 69.4619 48.0705 69.4619C49.2585 69.4619 50.2305 70.4279 50.2305 71.6159Z"
        fill={colors.white}
      />
      <defs>
        <linearGradient
          id="paint0_linear_1437_52001"
          x1="19.7686"
          y1="52.8066"
          x2="99.3946"
          y2="52.8066"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C5E2FF" />
          <stop offset="0.24" stopColor="#CAE4FF" />
          <stop offset="0.54" stopColor="#D8EBFF" />
          <stop offset="0.85" stopColor="#F1F8FF" />
          <stop offset="1" stopColor={colors.white} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1437_52001"
          x1="48.1348"
          y1="58.8803"
          x2="71.8468"
          y2="35.1623"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70B8FF" />
          <stop offset="1" stopColor="#C5E2FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1437_52001"
          x1="21.0946"
          y1="100.908"
          x2="62.8966"
          y2="100.908"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#70B8FF" />
          <stop offset="1" stopColor="#C5E2FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1437_52001"
          x1="45.8686"
          y1="95.8745"
          x2="45.8686"
          y2="67.1285"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C5E2FF" />
          <stop offset="1" stopColor="#70B8FF" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};

export default IntegrationErrorIcon;
